import { useNavigate, useParams } from "react-router-dom";
import useTemasNivel from "../../hooks/useTemasNivel";
import backgroundImage from "../../assets/img/fondoDoce.svg";
import volver from "../../assets/img/volver.svg";
import useNivelesUsuario from "../../hooks/useNivelesUsuario";

const TemasPorNivel = () => {
  const { tema } = useParams();
  const nivelRealId = Number(tema);

  const navegar = useNavigate();
  const usuarioGuardado = JSON.parse(localStorage.getItem("usuario"));

  const { niveles } = useNivelesUsuario();
  const idx = niveles.findIndex((n) => n.id === nivelRealId);
  const nivelVisual = idx >= 0 ? idx + 1 : nivelRealId;

  const { useTemas } = useTemasNivel(nivelRealId, usuarioGuardado?.id);
  const temas = Array.isArray(useTemas) ? useTemas : [];

  // ✅ helper para interpretar "completado"
  const isDone = (v) => v === 1 || v === "1" || v === true;

  // ✅ ¿Todos los temas del nivel están completos?
  const todosTemasCompletos =
    temas.length > 0 && temas.every((t) => isDone(t.completado));

  return (
    <div
      className="min-h-screen bg-cover bg-center flex flex-col justify-center items-center px-4"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-black">
        Temas del nivel {String(nivelVisual).padStart(2, "")}
      </h1>

      <div className="flex flex-col gap-4 w-full max-w-md">
        {temas.map((dato) => {
          const done = isDone(dato.completado);
          return (
            <button
              key={dato.id}
              disabled={done}
              className={`text-white font-semibold text-center text-base hover:brightness-125 shadow-lg justify-between rounded-lg px-8 py-4 transition-transform transform hover:scale-105 w-full hover:shadow-[0_9px_20px_rgba(0,0,0,0.4)] ${
                done ? "bg-gray-500 cursor-not-allowed" : "bg-green-700"
              }`}
              onClick={() => navegar(`/tema/multimedia/${dato.id}`)}
            >
              {dato.nombre}
            </button>
          );
        })}
      </div>

      {/* ⬇️ Botones inferiores: Desafío (condicional) + Volver (siempre) */}
      <div className="mt-20 flex flex-col items-center gap-4">
        {todosTemasCompletos && (
          <button
            onClick={() => navegar(`/evaluacion-final/nivel/${nivelRealId}`)}
            className="bg-green-700 text-white font-semibold rounded-lg px-8 py-4 transition-transform transform hover:scale-105 hover:brightness-110 shadow-lg"
            title="Desafío final del nivel"
          >
            Desafío final
          </button>
        )}

        <button
          onClick={() => navegar(-1)}
          className="relative group focus:outline-none"
          aria-label="Volver"
        >
          <img
            src={volver}
            alt="Volver atrás"
            className="h-16 w-auto transition-transform duration-300 group-hover:scale-105 active:scale-95"
          />
        </button>
      </div>
    </div>
  );
};

export default TemasPorNivel;
